import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Checkin from './Checkin';
import { ErrorToast } from '../utils/Utils';

export function CheckinWrapper({ questionList, setQustionList, responseQuestionIds }) {
  const [mcq, setMcq] = useState(questionList);
  const [slider, setSlider] = useState(questionList);
  const getInitalQuestion = () => {
    const initialQuestion = {
      id: uuidv4(),
      type: 'radio',
      text: '',
      options: {
        list: [
          { id: uuidv4(), text: '' },
          { id: uuidv4(), text: '' },
          { id: uuidv4(), text: '' },
          { id: uuidv4(), text: '' },
        ],
        mandatory: true,
      },
    };
    return initialQuestion;
  };
  const initialLinearScaleQuestion = {
    id: uuidv4(),
    type: 'slider',
    text: '',
    options: {
      max: 10,
      min: 1,
      step: 1,
    },
  };

  const handleAddQuestion = (questions) => {
    const newQuestion = getInitalQuestion();
    const updatedQuestions = [...questions, newQuestion];
    setQustionList(updatedQuestions);
    setMcq([...mcq, newQuestion]);
    setSlider([...slider, newQuestion]);
  };
  const handleAddOption = (questionIndex, questions) => {
    const updatedQuestions = [...questions];
    updatedQuestions[questionIndex].options.list.push({ text: '', id: uuidv4() });
    setQustionList(updatedQuestions);
    const temp = [...mcq];
    temp[questionIndex] = updatedQuestions[questionIndex];
    setMcq(temp);
  };

  const onChangeQuestionText = (e, questionIndex, questions) => {
    const updatedQuestions = [...questions];
    updatedQuestions[questionIndex].text = e.target.value;
    setQustionList(updatedQuestions);
    const temp1 = [...mcq];
    temp1[questionIndex].text = e.target.value;
    setMcq(temp1);
    const temp2 = [...slider];
    temp2[questionIndex].text = e.target.value;
    setSlider(temp2);
  };

  const onChangeOptionText = (e, questionIndex, optionIndex, questions) => {
    const updatedQuestions = [...questions];
    updatedQuestions[questionIndex].options.list[optionIndex].text = e.target.value;
    setQustionList(updatedQuestions);
    const temp1 = [...mcq];
    temp1[questionIndex] = updatedQuestions[questionIndex];
    setMcq(temp1);
  };

  const onChangeLinearScaleValue = (newValue, questionIndex, prop, questions) => {
    const updatedQuestions = [...questions];
    updatedQuestions[questionIndex].options[prop] = newValue;
    setQustionList(updatedQuestions);
    const temp2 = [...slider];
    temp2[questionIndex] = updatedQuestions[questionIndex];
    setSlider(temp2);
  };

  const onDeleteQuestion = (questionIndex, questions) => {
    const updatedQuestions = [...questions];
    const questionIdToDelete = updatedQuestions[questionIndex].id;
    const temp1 = [...mcq];
    const temp2 = [...slider];

    if (responseQuestionIds[questionIdToDelete]) {
      const confirmDelete = window.confirm('Are you sure you want to delete this question?');
      if (confirmDelete) {
        // Soft delete by marking the question as deleted
        updatedQuestions[questionIndex].deleted = true;
        temp1[questionIndex].deleted = true;
        temp2[questionIndex].deleted = true;
      }
    } else {
      updatedQuestions.splice(questionIndex, 1);
      temp1.splice(questionIndex, 1);
      temp2.splice(questionIndex, 1);
    }
    setQustionList(updatedQuestions);
    setMcq(temp1);
    setSlider(temp2);
  };

  const onDeleteOption = (questionId, questions, optionId, questionIndex) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === questionId) {
        const updatedOptions = question.options.list.filter((option) => option.id !== optionId);
        return {
          ...question,
          options: {
            ...question.options,
            list: updatedOptions,
          },
        };
      }
      return question;
    });

    setQustionList(updatedQuestions);
    const temp1 = [...mcq];
    temp1[questionIndex] = updatedQuestions[questionIndex];
    setMcq(temp1);
  };

  const onChangeQuestionType = (event, questionIndex, questions) => {
    const updatedQuestions = [...questions];
    const allMcqs = [...mcq];
    const allSliders = [...slider];
    const selectedType = event.target.value;
    const selectedQuestion = updatedQuestions[questionIndex];

    if (selectedType === 'slider') {
      const currentQuestion = slider[questionIndex];
      if (currentQuestion?.type === 'slider') {
        updatedQuestions[questionIndex] = currentQuestion;
        setQustionList(updatedQuestions);
      } else {
        updatedQuestions[questionIndex] = {
          ...initialLinearScaleQuestion,
          id: selectedQuestion.id,
          text: selectedQuestion.text,
        };
        allSliders[questionIndex] = updatedQuestions[questionIndex];
        setSlider(allSliders);
        setQustionList(updatedQuestions);
      }
    } else {
      // eslint-disable-next-line
      if (selectedQuestion.type === 'slider') {
        const currentQuestion = mcq[questionIndex];
        if (currentQuestion?.type !== 'slider') {
          currentQuestion.type = selectedType;
          updatedQuestions[questionIndex] = currentQuestion;
          setQustionList(updatedQuestions);
          allMcqs[questionIndex] = currentQuestion;
          setMcq(allMcqs);
        } else {
          const temp = getInitalQuestion();
          temp.id = selectedQuestion.id;
          temp.text = selectedQuestion.text;
          temp.type = selectedType;
          updatedQuestions[questionIndex] = temp;
          setQustionList(updatedQuestions);
          allMcqs[questionIndex] = temp;
          setMcq(allMcqs);
        }
      } else {
        const question = selectedQuestion;
        updatedQuestions[questionIndex] = {
          // eslint-disable-next-line no-undef
          ...question,
          id: updatedQuestions[questionIndex].id,
          type: selectedType,
        };
        setQustionList(updatedQuestions);
        allMcqs[questionIndex] = updatedQuestions[questionIndex];
        setMcq(allMcqs);
      }
    }
  };

  const getQuestionNumber = (i, questions) => {
    const adjustedIndex = i + 1;
    let adjustedCount = 0;

    for (let j = 0; j < questions.length; j += 1) {
      if (j === i) {
        break;
      }

      if (questions[j].deleted) {
        adjustedCount += 1;
      }
    }

    return adjustedIndex - adjustedCount;
  };

  return (
    <Checkin
      onDeleteQuestion={onDeleteQuestion}
      handleAddQuestion={handleAddQuestion}
      handleAddOption={handleAddOption}
      onChangeOptionText={onChangeOptionText}
      onChangeQuestionText={onChangeQuestionText}
      onChangeLinearScaleValue={onChangeLinearScaleValue}
      onChangeQuestionType={onChangeQuestionType}
      getQuestionNumber={getQuestionNumber}
      questions={questionList}
      responseQuestionIds={responseQuestionIds}
      onDeleteOption={onDeleteOption}
    />
  );
}

export const firstCheck = (questions) => {
  const isFieldEmpty = (field) => field.trim() === '';

  if (questions.length === 1 && isFieldEmpty(questions[0].text)) {
    const hasFilledOptions =
      questions[0].type !== 'slider' && questions[0].options.list.some((option) => !isFieldEmpty(option.text));
    if (!hasFilledOptions) {
      return true;
    }
  }
  return false;
};

export const validateCheckin = (questions) => {
  const isFieldEmpty = (field) => field.trim() === '';

  const firstcheck = firstCheck(questions);
  if (firstcheck) {
    return firstcheck;
  }

  const errors = [];

  questions.forEach((question) => {
    if (isFieldEmpty(question.text)) {
      errors.push('Question and Option fields cannot be empty');
    }

    if (question.type !== 'slider') {
      if (question.options.list.length < 2) {
        errors.push('Enter at least two answer options');
      } else {
        let optionEmpty = false;
        question.options.list.forEach((option) => {
          if (isFieldEmpty(option.text)) {
            optionEmpty = true;
          }
        });
        if (optionEmpty) {
          errors.push('Question and Option fields cannot be empty');
        }
      }
    }
  });

  if (errors.length > 0) {
    ErrorToast(errors[0]);
    return false;
  }

  return true;
};
